let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7fLPO")).then(() => parcelRequire('1A6Od'));